<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["RL"][obj_Role.Role.I > 0? "ERL": "ARL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAdd">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="6" v-if="obj_Role.Role.I <= 0">
                                            <label class='col-form-label-sm'>{{this.getLanguage["GL"]["AGT"]}}<span class="required" /> :</label>
                                            <customtreeselect :multiple="false"
                                                        :options="ddAgentList"
                                                        :defaultExpandLevel="Infinity"
                                                        @input="selectEditAgentOptions"
                                                        :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                        v-model="obj_Role.f_AGI" />
                                        </CCol>
                                        <CCol col="6" v-if="obj_Role.Role.I > 0">
                                            <label class='col-form-label-sm'>{{this.getLanguage["GL"]["AGT"]}}<span class="required" /> :</label>
                                            <CInput type="text" disabled="disabled" size="sm" vertical v-model="obj_Role.Role.AGN"></CInput>
                                        </CCol>
                                        <CCol col="6" v-if="checkIsSSA()">
                                            <label class="col-form-label-sm">{{this.getLanguage["RL"]["CA"]}}<span class="required" /> :</label>
                                            <input type="checkbox" class="inline-checkbox" true-value="1" false-value="0" v-model="obj_Role.Role.ISENS" /> {{this.getLanguage["RL"]["HSI"]}}
                                            <customtreeselect :multiple="true"
                                                        :options="ddAgentList_onlyagent"
                                                        :defaultExpandLevel="Infinity"
                                                        :flat="true"
                                                        :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                        :limit="1"
                                                        :limitText="count => `+${count}`"
                                                        v-model="obj_Role.Role.ACAGI" />
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="6">
                                            <label class='col-form-label-sm'>{{this.getLanguage["RL"]["RN"]}}<span class="required" /> :</label>
                                            <CInput :value="obj_Role.Role.RN" @change="v => obj_Role.Role.RN = v" size="sm" :disabled="obj_Role.Role.I > 0" />
                                        </CCol>
                                        <CCol col="6">
                                            <label class='col-form-label-sm'>{{this.getLanguage["GL"]["DV"]}}</label>
                                            <treeselect :multiple="false"
                                                        :load-options="loadDefaultOptions"
                                                        :options="ddDefaultRole"
                                                        :auto-load-root-options="false"
                                                        @input="ChangeDefaultSelect"
                                                        :placeholder="this.utilGetDDLanguage('GL.DV')" />
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-3">
                                        <CCol>
                                            <CCard>
                                                <CCardHeader>
                                                    <Strong>{{this.getLanguage["RL"]["RAU"]}}</Strong>
                                                </CCardHeader>
                                                <CCardBody>
                                                    <CRow class="roletable-inPopUp">
                                                        <CCol col="4"></CCol>
                                                        <CCol col="2">{{this.getLanguage["RL"]["AVI"]}}</CCol>
                                                        <CCol col="2">{{this.getLanguage["RL"]["AAD"]}}</CCol>
                                                        <CCol col="2">{{this.getLanguage["RL"]["AED"]}}</CCol>
                                                        <CCol col="2">{{this.getLanguage["RL"]["ADE"]}}</CCol>
                                                    </CRow>
                                                    <template v-for="(rol, index) in obj_Role.RoleAccessList">
                                                        <hr v-if="rol.HSM == false && (selectedAgentType != 4 || rol.VESAG == 1 || rol.AESAG == 1 || rol.EESAG == 1 || rol.DESAG == 1) && rol.C == false" />
                                                        <!-- Add ** Super Admin only-->
                                                        <CRow v-if="rol.HSM == false && (!(rol.VSSAAO && rol.ASSAAO && rol.ESSAAO && rol.DSSAAO) || checkIsSSA()) && (selectedAgentType != 4 || rol.VESAG == 1 || rol.AESAG == 1 || rol.EESAG == 1 || rol.DESAG == 1)">
                                                            <CCol col="4">
                                                                <span v-if="rol.C">
                                                                    <span v-if="rol.SPI == 0 || rol.ISF"><span class="special_Function">➤</span> {{getLanguage["SMB"][rol.MN]}}</span>
                                                                    <span v-else>{{rol.MPI}}.{{rol.SPI}} {{ getLanguageOEMI(int_OEMId,"SMB",rol.MN) }}</span>
                                                                </span>
                                                                <b v-if="rol.C == false">{{rol.MPI}} {{ getLanguageOEMI(int_OEMId,"SMB",rol.MN) }}</b>
                                                            </CCol>
                                                            <CCol col="2" v-if="rol.MN != rol.PM">
                                                                <input v-if="rol.VAMId > 0 && (!rol.VSSAAO || checkIsSSA()) && (selectedAgentType != 4 || rol.VESAG == 1)" type="checkbox" :checked="rol.VA >= 0" @click="tickRoleAccessCheckbox($event, rol, 1)" />
                                                                <!--<span v-if="rol.VAMId > 0">
                                                                <span v-if="rol.ESA == 0 && rol.EMA == 0 && rol.EAG == 0">-->
                                                                <span v-if="rol.VE" class="mandatory_Field">**</span>
                                                                <span v-if="rol.s_assign && rol.VSSAAO && rol.VAMId > 0 && checkIsSSA()" class="mandatory_Field" style="color: blue;">*</span>
                                                                <!--</span>
                                                                </span>-->
                                                            </CCol>
                                                            <CCol col="2" v-if="rol.MN != rol.PM">
                                                                <input v-if="rol.AAMId > 0 && (!rol.ASSAAO || checkIsSSA()) && (selectedAgentType != 4 || rol.AESAG == 1)" type="checkbox" :checked="rol.AA >= 0" @click="tickRoleAccessCheckbox($event, rol, 2)" />
                                                                <span v-if="rol.AE" class="mandatory_Field">**</span>
                                                                <span v-if="rol.s_assign && rol.ASSAAO && rol.AAMId > 0 && checkIsSSA()" class="mandatory_Field" style="color: blue;">*</span>
                                                            </CCol>
                                                            <CCol col="2" v-if="rol.MN != rol.PM">
                                                                <input v-if="rol.EAMId > 0 && (!rol.ESSAAO || checkIsSSA())&& (selectedAgentType != 4 || rol.EESAG == 1)" type="checkbox" :checked="rol.EA >= 0" @click="tickRoleAccessCheckbox($event, rol, 3)" />
                                                                <span v-if="rol.EE" class="mandatory_Field">**</span>
                                                                <span v-if="rol.s_assign && rol.ESSAAO && rol.EAMId > 0 && checkIsSSA()" class="mandatory_Field" style="color: blue;">*</span>
                                                            </CCol>
                                                            <CCol col="2" v-if="rol.MN != rol.PM">
                                                                <input v-if="rol.DAMId > 0 && (!rol.DSSAAO || checkIsSSA()) && (selectedAgentType != 4 || rol.DESAG == 1)" type="checkbox" :checked="rol.DA >= 0" @click="tickRoleAccessCheckbox($event, rol, 4)" />
                                                                <span v-if="rol.DE" class="mandatory_Field">**</span>
                                                                <span v-if="rol.s_assign && rol.DSSAAO && rol.DAMId > 0 && checkIsSSA()" class="mandatory_Field" style="color: blue;">*</span>
                                                            </CCol>
                                                        </CRow>
                                                        <div v-if="rol.HSM == true && rol.SMN.length > 0 && checkSubModuleAccess(rol.SMN)">
                                                            <b v-if="rol.SMN.length > 0"><i>{{checkSubModuleIndex(rol.MPI, rol.PM, rol.SMN, rol.SMI)}} {{getLanguage["SMB"][rol.SMN]}}</i></b>
                                                            <template v-for="(rolsub, index) in obj_Role.RoleAccessList" v-if="rolsub.HSM == true && rol.SMN == rolsub.SPM">
                                                                <!-- Add ** Super Admin only-->
                                                                <CRow v-if="rolsub.HSM == true && (!(rolsub.VSSAAO && rolsub.ASSAAO && rolsub.ESSAAO && rolsub.DSSAAO) || checkIsSSA()) && (selectedAgentType != 4 || rolsub.VESAG == 1 || rolsub.AESAG == 1 || rolsub.EESAG == 1 || rolsub.DESAG == 1)">
                                                                    <CCol col="4">
                                                                        <span v-if="rolsub.C">
                                                                            <span v-if="rolsub.SPI == 0 || rolsub.ISF"><span class="special_Function">➤</span> {{getLanguage["SMB"][rolsub.MN]}}</span>
                                                                            <span v-else-if="rolsub.MN == 'DR2' && rol.PM == 'R'">{{checkModuleIndex(rolsub.MN, rol.PM, constAccessType.view, rol.SMN, rol.SMI)}} {{ getLanguageOEMI(int_OEMId,"SMB","D") }}</span>
                                                                            <span v-else-if="rolsub.MN == 'WR2' && rol.PM == 'R'">{{checkModuleIndex(rolsub.MN, rol.PM, constAccessType.view, rol.SMN, rol.SMI)}} {{ getLanguageOEMI(int_OEMId,"SMB","W") }}</span>
                                                                            <span v-else>{{checkModuleIndex(rolsub.MN, rol.PM, constAccessType.view, rol.SMN, rol.SMI)}} {{ getLanguageOEMI(int_OEMId,"SMB",rolsub.MN) }}</span>
                                                                        </span>
                                                                        <b v-if="rolsub.C == false">{{rolsub.MPI}} {{ getLanguageOEMI(int_OEMId,"SMB",rolsub.MN) }}</b>
                                                                    </CCol>
                                                                    <CCol col="2" v-if="rolsub.MN != rolsub.PM">
                                                                        <input v-if="rolsub.VAMId > 0 && (!rolsub.VSSAAO || checkIsSSA()) && (selectedAgentType != 4 || rolsub.VESAG == 1)" type="checkbox" :checked="rolsub.VA >= 0" @click="tickRoleAccessCheckbox($event, rolsub, 1)" />
                                                                        <span v-if="rolsub.VE" class="mandatory_Field">**</span>
                                                                        <span v-if="rolsub.s_assign && rolsub.VSSAAO && rolsub.VAMId > 0 && checkIsSSA()" class="mandatory_Field" style="color: blue;">*</span>                                                                        
                                                                    </CCol>
                                                                    <CCol col="2" v-if="rolsub.MN != rolsub.PM">
                                                                        <input v-if="rolsub.AAMId > 0 && (!rolsub.ASSAAO || checkIsSSA()) && (selectedAgentType != 4 || rolsub.AESAG == 1)" type="checkbox" :checked="rolsub.AA >= 0" @click="tickRoleAccessCheckbox($event, rolsub, 2)" />
                                                                        <span v-if="rolsub.AE" class="mandatory_Field">**</span>
                                                                        <span v-if="rolsub.s_assign && rolsub.ASSAAO && rolsub.AAMId > 0 && checkIsSSA()" class="mandatory_Field" style="color: blue;">*</span>
                                                                    </CCol>
                                                                    <CCol col="2" v-if="rolsub.MN != rolsub.PM">
                                                                        <input v-if="rolsub.EAMId > 0 && (!rolsub.ESSAAO || checkIsSSA())&& (selectedAgentType != 4 || rolsub.EESAG == 1)" type="checkbox" :checked="rolsub.EA >= 0" @click="tickRoleAccessCheckbox($event, rolsub, 3)" />
                                                                        <span v-if="rolsub.EE" class="mandatory_Field">**</span>
                                                                        <span v-if="rolsub.s_assign && rolsub.ESSAAO && rolsub.EAMId > 0 && checkIsSSA()" class="mandatory_Field" style="color: blue;">*</span>
                                                                    </CCol>
                                                                    <CCol col="2" v-if="rolsub.MN != rolsub.PM">
                                                                        <input v-if="rolsub.DAMId > 0 && (!rolsub.DSSAAO || checkIsSSA()) && (selectedAgentType != 4 || rolsub.DESAG == 1)" type="checkbox" :checked="rolsub.DA >= 0" @click="tickRoleAccessCheckbox($event, rolsub, 4)" />
                                                                        <span v-if="rolsub.DE" class="mandatory_Field">**</span>
                                                                        <span v-if="rolsub.s_assign && rolsub.DSSAAO && rolsub.DAMId > 0 && checkIsSSA()" class="mandatory_Field" style="color: blue;">*</span>
                                                                    </CCol>
                                                                </CRow>
                                                            </template>
                                                        </div>
                                                    </template>
                                                </CCardBody>
                                            </CCard>
                                        </CCol>
                                    </CRow>
                                    <CRow class="mt-3">
                                        <CCol>
                                            <label class="col-form-label-sm">{{this.getLanguage["RL"]["RMRK"]}} :</label>
                                            <textarea v-shortkey.avoid vertical="" rows="2" class="form-control form-control-sm" :value="obj_Role.Role.R" @change="TextValueChange('Role.R',$event)" />
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveRole()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                                <label class="special_Function mr-2">{{this.getLanguage['SPECIAL']['FUNCTION']}}</label>
                                <label class="mandatory_Field mr-2">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>
                                <label class="mandatory_Field mr-2" v-if="this.getUserInfo.AT == 0">{{this.getLanguage['ACU']['SAO']}}</label>
                                <label class="mandatory_Field mr-2" style="color: blue;" v-if="this.getUserInfo.AT == 0">{{this.getLanguage['ACU']['SAAO']}}</label>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["RL"]["MSR"]}}</h2>
                        <CButton size="sm" color="outline-info" v-if="checkModuleAccess2(constAccessType.add)" @click="addRole()"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <!--<div class='searchCol' v-if="checkIsSSA()">-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['AGT']}}</span>
                                <customtreeselect :multiple="false"
                                            :options="ddAgentListfs"
                                            :defaultExpandLevel="Infinity"
                                            :auto-load-root-options="convertToBool(searchAgent)"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            v-model="searchAgent" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["RL"]["RN"]}}:</span>
                                <CInput size="sm"
                                        :value="str_FV[0].FV" @change="v => str_FV[0].FV = v" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="str_FV[1].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[1].FV.startDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[1].FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="str_FV[1].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[1].FV.endDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[1].FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click="newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header">
                    <strong> {{this.getLanguage["RL"]["MSRL"]}}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}<i @click="setSortTable('I')" :class="setSortLogo('I')" class="sortlogo"></i></th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th>
                                    {{this.getLanguage['GL']['AGT']}}
                                    <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{this.getLanguage["RL"]["RN"]}}
                                    <i @click="setSortTable('RN')" :class="setSortLogo('RN')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{this.getLanguage["GL"]["CT"]}}
                                    <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{this.getLanguage["GL"]["CB"]}}
                                </th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}<i @click="setSortTable('I')" :class="setSortLogo('I')" class="sortlogo"></i></th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th>
                                    {{this.getLanguage['GL']['AGT']}}
                                    <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{this.getLanguage["RL"]["RN"]}}
                                    <i @click="setSortTable('RN')" :class="setSortLogo('RN')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{this.getLanguage["GL"]["CT"]}}
                                    <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                </th>
                                <th>
                                    {{this.getLanguage["GL"]["CB"]}}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_Role.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_Role">
                            <td>{{ CountItem(index+1) }}</td>
                            <td v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">
                                <span id="actionBtnCol">
                                    <div v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && (data.AGI == curAGI || subAGISet(data.AGI))) || isSENS == 0)" class="custom-tooltip">
                                        <i class="cil-trash" @click="removeRole(data)"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI && !subAGISet(data.AGI))" class="custom-tooltip">
                                        <i class="cil-trash"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && (data.AGI == curAGI || subAGISet(data.AGI))) || isSENS == 0)" class="custom-tooltip">
                                        <i class="cil-color-border" @click="editRole(data.I,data.AGI)"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                    <div v-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI && !subAGISet(data.AGI))" class="custom-tooltip">
                                        <i class="cil-color-border"></i>
                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                </span>
                            </td>
                            <td>{{ data.AGN }} ({{ data.PC }}) </td>
                            <td>{{ data.RN }}</td>
                            <td>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td>{{ data.CB }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import DateRangePicker from 'vue2-daterange-picker'
    import moment from "moment";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters, mapActions } from 'vuex';
    import genericHelper from "@/modules/GenericHelper.js";
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading,
            DateRangePicker
        },
        data() {
            return {
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                //sensBtn: true,
                str_FV: [{ F: "RoleName" }, { F: "CTS", FV: { startDate: "", endDate: "" } }], //Filter Value
                bool_isAMV: false, // Add Modal Visible
                bool_showSearchBar: true,
                bool_CV: false,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                arr_Role: [],
                obj_Role: {},
                ddAgentList: null,
                ddAgentListfs: null,
                ddAgentList_onlyagent: null,
                searchAgent: null,
                ddDefaultRole: null,
                constAccessType: constAccessType,
                selectedAgentType: -1,
                selectedAgentGroup: 0,
                int_OEMId: 0,
                isSENS: 0,
                ChangeView: false,
                subAGISet(agi) {
                    var bCheck = false;
                    for (var i = 0; i < this.subAGI.length; i++) {
                        if (agi == this.subAGI[i].I)
                            bCheck = true;
                    }
                    return bCheck;
                }

            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkMenuAccess', 'checkModuleAccess', 'checkModuleIndex', 'checkSubModuleAccess', 'checkSubModuleIndex']),            
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getRoleList();
            },
        },
        methods: {
            ...mapActions('UserInfo', ['setUser']),
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[1].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[1].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[1].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[1].FV.endDate = "";
                    }
                }
            },
            TextValueChange(type, event) {
                if (type == "Role.R") {
                    this.obj_Role.Role.R = event.target.value;
                }
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('CRR', 'SYS', type);
            },
            checkIsSSA() {
                return this.getUserInfo.AT == 0;
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getRoleList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getRoleList();
                }
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getRoleList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getRoleList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (this.str_FV) {
                    if (this.str_FV[0].FV != null && this.str_FV[1].FV != "") {
                        path += ("&f.RoleName=" + this.str_FV[0].FV);
                    }
                    if (this.str_FV[1].FV.startDate != "") {
                        var cts_from = this.parseDateToJsonString(this.str_FV[1].FV.startDate);
                        path += "&f[CTS_from]=" + cts_from;
                    }
                    if (this.str_FV[1].FV.endDate != "") {
                        var cts_to = this.parseDateToJsonString(this.str_FV[1].FV.endDate);
                        path += "&f[CTS_to]=" + cts_to;
                    }
                }

                if (this.searchAgent) {
                    // for multi select
                    /*for (var i = 0; i < this.searchAgent.length; i++) {
                        if (path) {
                            path += "&";
                        }

                        var agentList = this.searchAgent[i].split("-");
                        var agentGId = agentList[agentList.length - 1];
                        path += ("f.Agi=" + agentGId);
                    }*/

                    if (path) {
                        path += "&";
                    }

                    var agentList = this.searchAgent.split("-");
                    var agentGId = agentList[agentList.length - 1];
                    path += ("f.Agi=" + agentGId);
                }

                this.getDataApi(`/api/role/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.setRoleList(d);
                            that.resizeTableHead();
                        }
                    });
            },
            setRoleList(data) {
                this.int_TP = Math.max(data.D.TotalPages, 1);
                this.int_Total = data.D.TotalItems;
                if (data.D.Items == null) {
                    this.arr_Role = [];
                }
                else {
                    this.arr_Role = data.D.Items;
                }                
            },
            addRole() {
                this.bool_CV = false;
                this.bool_fullLoading = true;
                var that = this;

                var ism = 0;
                if (localStorage.getItem('isSimpleMode') === 'True') { ism = 1 };
                this.getDataApi(`/api/role/g/0/0/${ism}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.setRole(d);
                        }
                    });
            },
            setRole(data) {                
                this.obj_Role = data;                
                this.obj_Role.RoleAccessList = _.sortBy(this.obj_Role.RoleAccessList, [(item) => parseInt(item.MPI, 10), 'SPM', (item) => parseInt(item.SPI, 10)]);

                this.obj_Role.Role.ACAGI = [];                                                              
                if (this.obj_Role.Role.CrossAgentGroupId != null) {
                    for (var i = 0; i < this.obj_Role.Role.CrossAgentGroupId.length; i++) {
                        this.obj_Role.Role.ACAGI.push("3-" + this.obj_Role.Role.CrossAgentGroupId[i])
                    }
                }
                
                this.selectedAgentType = this.obj_Role.Role.AT;

                if (this.obj_Role && this.obj_Role.Role && this.obj_Role.Role.AT) {                                        

                    if (this.obj_Role.Role.AT < 3) {                        
                        this.ddAgentList_onlyagent.forEach(this.disableAgentGroupParent);
                    }
                    else {                        
                        this.ddAgentList_onlyagent.forEach(this.disableAgentGroup);
                    }                                                                   
                }

                this.bool_isAMV = true;
            },
            removeRole(d) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS,
                            agi: d.AGI
                        };

                        this.postDataApi(`/api/role/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getRoleList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                    that.$root.UserInfo.getInfoApi(that);
                                }
                            });
                    }
                });
            },
            editRole(id, agi) {                
                this.bool_fullLoading = true;                
                var that = this;

                var ism = 0;
                if (localStorage.getItem('isSimpleMode') === 'True') { ism = 1 };
                this.getDataApi(`/api/role/g/${id}/${agi}/${ism}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.setRole(d);
                        }
                    });
            },
            setDefaultRole(id) {
                this.bool_fullLoading = true;
                var that = this;
                var is_success = true;
                var ism = 0;
                if (localStorage.getItem('isSimpleMode') === 'True') { ism = 1 };

                if (id == undefined || !this.obj_Role.Role.AGI) {
                    is_success = false;
                } else {
                    this.getDataApi(`/api/role/gv/${id}/${that.obj_Role.Role.AGI}/${ism}/1`,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.obj_Role.RoleAccessList = d.RoleAccessList;
                                that.obj_Role.RoleAccessList = _.sortBy(that.obj_Role.RoleAccessList, [(item) => parseInt(item.MPI, 10), 'SPM', (item) => parseInt(item.SPI, 10)]);
                            } else {
                                is_success = false
                            }
                        });
                }
                if (is_success == false) {
                    this.getDataApi(`/api/role/g/0/0/${ism}`,
                        function (d, s) {
                            that.bool_fullLoading = false;

                            if (s) {
                                that.obj_Role.RoleAccessList = d.RoleAccessList;
                                that.obj_Role.RoleAccessList = _.sortBy(that.obj_Role.RoleAccessList, [(item) => parseInt(item.MPI, 10), 'SPM', (item) => parseInt(item.SPI, 10)]);
                            }
                        });
                }
            },
            saveRole() {
                this.bool_CV = true;
                var that = this;
                this.bool_fullLoading = true;
                this.bool_fullScreen = true;
                var agi = [];
                if (this.obj_Role.Role.ACAGI != null && this.obj_Role.Role.ACAGI.length > 0) {
                    for (var i = 0; i < this.obj_Role.Role.ACAGI.length; i++) {
                        var temp = this.obj_Role.Role.ACAGI[i].split("-");
                        agi.push(temp[1])
                    }
                }
                this.obj_Role.Role.ACAGI = '';
                this.obj_Role.Role.LAGI = agi;

                this.postDataApi(`/api/role/s`, this.obj_Role,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        that.bool_fullScreen = false;
                        if (s) {
                            that.bool_isAMV = false;
                            that.getRoleList();
                            that.$root.UserInfo.getInfoApi(that);
                        }
                    });
            },
            tickRoleAccessCheckbox(event, data, type) {
                var val = -1;
                if (event.target.checked) {
                    val = 0;
                }

                for (var i = 0; i < this.obj_Role.RoleAccessList.length; i++) {
                    if (this.obj_Role.RoleAccessList[i].MN == data.MN && this.obj_Role.RoleAccessList[i].PM == data.PM) {
                        switch (type) {
                            case 1:
                                this.obj_Role.RoleAccessList[i].VA = val;
                                break;
                            case 2:
                                this.obj_Role.RoleAccessList[i].AA = val;
                                break;
                            case 3:
                                this.obj_Role.RoleAccessList[i].EA = val;
                                break;
                            case 4:
                                this.obj_Role.RoleAccessList[i].DA = val;
                                break;
                        }

                        break;
                    }
                }
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag-sub/1/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddAgentListfs = that.deepClone(d.dropdownlist);
                            that.ddAgentList = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.ddAgentList = that.ddAgentList.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }
                            
                        }
                        else {
                            that.ddAgentListfs = null;
                            that.ddAgentList = null;
                        }
                    });

            },
            getAgentGroupOnly() {                
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {                                
                            that.ddAgentList_onlyagent = that.deepClone(d.dropdownlist);
                            if (that.ddAgentList_onlyagent.length > 0) {
                                that.ddAgentList_onlyagent.forEach(that.disableAgentGroupParent);                                
                            }                            
                        }
                        else {                            
                            that.ddAgentList_onlyagent = null;                            
                        }
                    });

            },            
            disableAgentGroupParent(item, index) {                
                var agi = item.id.split("-");
                if (agi[0] < 3) {
                    this.$set(item, 'isDisabled', true);                                        
                    
                    if ((this.obj_Role && this.obj_Role.Role && this.obj_Role.Role.AGI) || this.selectedAgentGroup != 0) {                        
                        if (agi[1] == this.obj_Role.Role.AGI || agi[1] == this.selectedAgentGroup) {
                            if (item.children && item.children.length > 0) {                                
                                // Set isDisabled for all children recursively                            
                                this.setIsDisabledRecursively(item.children, true);                                
                            }
                        }
                        else {
                            this.setIsDisabledRecursively(item.children, false);
                        }
                    }
                }
                               
                if (item.children && item.children.length > 0) {
                    item.children.forEach(child => this.disableAgentGroupParent(child));
                }               
            },
            disableAgentGroup(item, index) {                                
                var agi = item.id.split("-");
                if (agi[0] < 3) {
                    this.$set(item, 'isDisabled', true);
                }
                else {                    
                    if ((this.obj_Role && this.obj_Role.Role && this.obj_Role.Role.AGI) || this.selectedAgentGroup != 0) {                                                
                        if (agi[1] == this.obj_Role.Role.AGI || agi[1] == this.selectedAgentGroup) {                            
                            this.$set(item, 'isDisabled', true);                                                        
                        }
                        else {
                            this.$set(item, 'isDisabled', false);                            
                        }                        
                    }
                }
                
                if (item.children && item.children.length > 0) {
                    item.children.forEach(child => this.disableAgentGroup(child));
                }                
            },
            setIsDisabledRecursively(children, value) {                
                if (Array.isArray(children)) {
                    children.forEach(child => {
                        child.isDisabled = value; // Set isDisabled for the current child                        
                        if (child.children && child.children.length > 0) {
                            this.setIsDisabledRecursively(child.children, value); // Recursively set for nested children
                        }
                    });
                }
            },
            loadDefaultOptions({ action, callback, instanceId }) {
                var that = this;
                if (!this.obj_Role.Role.AGI) {
                    callback(this.getLanguage['MEM']['PSAA']);
                }
                else {
                    this.getDataApi(`/api/dd/dr/0`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddDefaultRole = d.dropdownlist;
                                that.ddDefaultRole = that.ddDefaultRole.splice(1);
                            }
                            else {
                                that.ddDefaultRole = null;
                            }

                            callback();
                        });
                }
            },
            selectEditAgentOptions(value, instanceId) {
                if (this.obj_Role.f_AGI) {                    
                    var agentList = this.obj_Role.f_AGI.split("-");
                    this.obj_Role.Role.AGI = agentList[agentList.length - 1];
                    this.selectedAgentType = agentList[0];
                    this.selectedAgentGroup = agentList[1];
                    
                    if (agentList[0] < 3) {                        
                        this.ddAgentList_onlyagent.forEach(this.disableAgentGroupParent);
                    }
                    else {                        
                        this.ddAgentList_onlyagent.forEach(this.disableAgentGroup);
                    }

                    this.ddAgentList_onlyagent = [...this.ddAgentList_onlyagent]; // Create a new reference

                    if (agentList[0] == '4') {
                        if (this.obj_Role && this.obj_Role.Role.ACAGI) {
                            this.obj_Role.Role.ACAGI = null;
                        }
                    }                    

                    var that = this;
                    var ism = 0;
                    if (localStorage.getItem('isSimpleMode') === 'True') { ism = 1 };
                    this.getDataApi(`/api/role/g/0/${agentList[agentList.length - 1]}/${ism}`,
                        function (d, s) {
                            that.bool_fullLoading = false;

                            if (s) {

                                that.obj_Role.RoleAccessList = d.RoleAccessList;
                                that.obj_Role.RoleAccessList = _.sortBy(that.obj_Role.RoleAccessList, [(item) => parseInt(item.MPI, 10), 'SPM', (item) => parseInt(item.SPI, 10)]);
                            }
                        });
                }
                else {
                    this.selectedAgentType = -1;
                }
                //this.sensBtn = ((this.isSENS == 1 && agentList[agentList.length - 1] != this.curAGI) ? true : false);
            },
            ChangeDefaultSelect(value) {
                this.setDefaultRole(value);
            },
            clearDateRangeFilter() {
                this.str_FV[1].FV = {
                    startDate: "",
                    endDate: ""
                };
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
        },
        created() {
            this.$parent.showSubMenu = 'SYS';
            this.$parent.showActiveMenu = 'SYS.CRR';
            this.int_OEMId = this.getUserInfo.OEMI;
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            this.getRoleList();
            this.getAgentGroup();
            this.getAgentGroupOnly();
            this.subAGI = this.getUserInfo.AGIBYPGI;
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/SideMenu/SystemSetting/CreateRole.vue